"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GdprAnonymizeTypeEnum = void 0;
var GdprAnonymizeTypeEnum;
(function (GdprAnonymizeTypeEnum) {
    GdprAnonymizeTypeEnum["Anonymize"] = "Anonymize";
    GdprAnonymizeTypeEnum["Delete"] = "Delete";
})(GdprAnonymizeTypeEnum = exports.GdprAnonymizeTypeEnum || (exports.GdprAnonymizeTypeEnum = {}));
